import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { ConfirmDialog } from "@/shared/ui";

interface NarrativeOnlyWarningModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const NarrativeOnlyWarningModal = ({
  open,
  onClose,
  onConfirm,
}: NarrativeOnlyWarningModalProps) => {
  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      tone="warning"
      icon={<WarningAmberIcon />}
      title="Submit Narrative Only?"
      description="You are submitting with Narrative Only mode enabled. General
        Information and the Narrative will be submitted; other report
        information (subjects, vehicles, offenses, etc.) will not be included.
        Are you sure you want to continue?"
      confirmLabel="Submit Narrative Only"
    />
  );
};
